

import { useTranslation } from 'react-i18next'
import "./NotiFirstUsage.css"

export default function NotiFirstUsage({showNotiFirstUsage, goManual}) {
  const { t } = useTranslation();

  return (<>
  <div className={`first-usage ${showNotiFirstUsage ? "show-noti" : "" }`} >
    <p><b>{t('notiFirstUsage.noAccount')}</b></p>
    <p><b>{t('notiFirstUsage.addGuide')}</b></p>
    <div className="first-usage-guide">
      <h3>{t('notiFirstUsage.referManual')}</h3>
      <button onClick={goManual}><b>{t('notiFirstUsage.goManual')}</b></button>
    </div>
  </div>
  </>)
}
